import Dashboard from "views/Dashboard/Dashboard";

import ListCustomers from "views/Customers/List";
import EditCustomer from "views/Customers/Edit";
import ViewCustomer from "views/Customers/View";

import ListBuildings from "views/Buildings/List";
import EditBuilding from "views/Buildings/Edit";
import ViewBuilding from "views/Buildings/View";

import ListDevices from "views/Devices/List";
import EditDevice from "views/Devices/Edit";
import ViewDevice from "views/Devices/View";
import Elevators from "views/Elevators";
import TroubleshootingDashboard from "views/TroubleshootingDashboard/TroubleshootingDashboard";
import ViewAlert from "views/Alerts/View";

import CallCenter from "views/CallCenter/CallCenter";

import CallReport from "views/Forms/CallReport";
import ElevatorReport from "views/Forms/ElevatorReport";
import Dispatch911Report from "views/Forms/Dispatch911Report";

import ListReports from "views/Reports/List";
import ViewReport from "views/Reports/View";

import ListElevatorCompanies from "views/ElevatorCompanies/List"
import EditElevatorCompany from "views/ElevatorCompanies/Edit"
import ViewElevatorCompany from "views/ElevatorCompanies/View"

import ListUserLogs from "views/UserLogs/List"

import ListCallLogs from "views/CallLogs/List"
import ViewCallLog from "views/CallLogs/View"

import ListPhoneNumber from "views/PhoneNumbers/List";
import EditPhoneNumber from "views/PhoneNumbers/Edit"
import ViewPhoneNumber from "views/PhoneNumbers/View"

import ListBlockedPhoneNumber from "views/BlockedPhoneNumbers/List";
import EditBlockedPhoneNumber from "views/BlockedPhoneNumbers/Edit"
import ViewBlockedPhoneNumber from "views/BlockedPhoneNumbers/View"

import ListAdminSettings from "views/AdminSettings/List"
import ListSettings from "views/Settings/List"
import EditSetting from "views/Settings/Edit"
import ViewSetting from "views/Settings/View"
import EditPbxGroup from "views/PbxGroups/Edit"
import ViewPbxGroup from "views/PbxGroups/View"

import ListContactStatusLogs from "views/ContactStatusLogs/List"

let routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: "las la-stream",
    component: Dashboard,
    layout: "/admin",
  },
  {
    path: "/customers",
    name: "Customers",
    state: "openPages",
    icon: "now-ui-icons users_single-02",
    component: ListCustomers,
    mini: "CU",
    layout: "/admin",
    exact: true,
    requiredPermissions: ["all:customers", "read:customers"]
  },
  {
    path: "/customers/add",
    name: "Add Customer",
    component: EditCustomer,
    layout: "/admin",
    invisible: true,
    exact: true,
  },
  {
    path: "/customers/:id",
    name: "Customer",
    component: ViewCustomer,
    layout: "/admin",
    invisible: true,
    exact: true,
  },
  {
    path: "/customers/:id/edit",
    name: "Edit Customer",
    component: EditCustomer,
    layout: "/admin",
    invisible: true,
    exact: true,
  },
  {
    path: "/buildings",
    name: "Buildings",
    mini: "BG",
    component: ListBuildings,
    icon: "las la-city",
    layout: "/admin",
    exact: true,
    defaultQueryParams: "?f_active=Active",
    requiredPermissions: ["all:buildings", "read:buildings"]
  },
  {
    path: "/buildings/:id",
    name: "Buildings",
    component: ViewBuilding,
    layout: "/admin",
    invisible: true,
    exact: true,
  },
  {
    path: "/buildings/:customerId/add",
    name: "Buildings",
    component: EditBuilding,
    layout: "/admin",
    invisible: true,
    exact: true,
  },
  {
    path: "/buildings/:id/edit",
    name: "Buildings",
    component: EditBuilding,
    layout: "/admin",
    invisible: true,
    exact: true,
  },
  {
    path: "/buildings/company/:elevatorCompanyId/add",
    name: "Buildings",
    component: EditBuilding,
    layout: "/admin",
    invisible: true,
    exact: true,
  },
  {
    path: "/elevators",
    name: "Elevators",
    mini: "DE",
    icon: "las la-columns",
    component: Elevators.List,
    layout: "/admin",
    exact: true,
    requiredPermissions: ["all:buildings", "read:buildings"]
  },
  {
    path: "/elevators/:id",
    name: "Elevators",
    component: Elevators.View,
    layout: "/admin",
    invisible: true,
    exact: true,
  },
  {
    path: "/elevators/:customerId|:buildingId/add",
    name: "Elevators",
    component: Elevators.Edit,
    layout: "/admin",
    invisible: true,
    exact: true,
  },
  {
    path: "/elevators/:id/edit",
    name: "Elevators",
    component: Elevators.Edit,
    layout: "/admin",
    invisible: true,
    exact: true,
  },
  {
    path: "/elevators/company/:buildingId/add",
    name: "Elevators",
    component: Elevators.Edit,
    layout: "/admin",
    invisible: true,
    exact: true,
  },
  {
    path: "/troubleshooting",
    name: "Troubleshooting",
    mini: "TD",
    icon: "las la-tools",
    component: TroubleshootingDashboard,
    layout: "/admin",
    exact: true,
    requiredPermissions: ["read:troubleshooting_dashboard"]
  },

  {
    path: "/devices",
    name: "Devices",
    mini: "DE",
    icon: "now-ui-icons tech_mobile",
    component: ListDevices,
    layout: "/admin",
    invisible: true,
    exact: true,
  },
  {
    path: "/devices/:id",
    name: "Devices",
    component: ViewDevice,
    layout: "/admin",
    invisible: true,
    exact: true,
  },
  {
    path: "/devices/:customerId|:buildingId/add",
    name: "Devices",
    component: EditDevice,
    layout: "/admin",
    invisible: true,
    exact: true,
  },
  {
    path: "/devices/:id/edit",
    name: "Devices",
    component: EditDevice,
    layout: "/admin",
    invisible: true,
    exact: true,
  },
  {
    path: "/alerts/:id",
    name: "Alert",
    component: ViewAlert,
    layout: "/admin",
    invisible: true,
    exact: true,
  },
  {
    path: "/call",
    name: "Elevator Report",
    component: ElevatorReport,
    layout: "/admin",
    invisible: true,
    exact: true,
  },
  {
    path: "/call/:id",
    name: "Call Report",
    component: CallReport,
    layout: "/admin",
    invisible: true,
    exact: true,
  },
  {
    path: "/dispatch911/:id",
    name: "911 Dispatch Report",
    component: Dispatch911Report,
    layout: "/admin",
    invisible: true,
    exact: true,
  },
  {
    path: "/elevatorcompanies",
    name: "Elevator Companies",
    mini: "EC",
    icon: "las la-user-friends",
    component: ListElevatorCompanies,
    layout: "/admin",
    exact: true,
    requiredPermissions: ["all:elevator_companies", "read:elevator_companies"]
  },
  {
    path: "/elevatorcompanies/add",
    name: "Add Elevator Company",
    component: EditElevatorCompany,
    layout: "/admin",
    invisible: true,
    exact: true,
  },
  {
    path: "/elevatorcompanies/:id",
    name: "View Elevator Company",
    component: ViewElevatorCompany,
    layout: "/admin",
    invisible: true,
    exact: true,
  },
  {
    path: "/elevatorcompanies/:id/edit",
    name: "Edit Elevator Company",
    component: EditElevatorCompany,
    layout: "/admin",
    invisible: true,
    exact: true,
  },
  {
    path: "/callcenter",
    name: "Call Center",
    icon: "las la-phone-volume",
    component: CallCenter,
    layout: "/admin",
    exact: true,
    requiredPermissions: ["all:agent"]
  },
  {
    path: "/reports",
    name: "Call Reports",
    mini: "RP",
    component: ListReports,
    icon: "las la-file-alt",
    layout: "/admin",
    exact: true,
    requiredPermissions: ["all:calls", "read:calls"]
  },
  {
    path: "/reports/:id",
    name: "Reports",
    component: ViewReport,
    layout: "/admin",
    invisible: true,
    exact: true,
  },
  {
    path: "/calllogs",
    name: "Call Logs",
    mini: "CL",
    component: ListCallLogs,
    icon: "las la-phone-square",
    layout: "/admin",
    exact: true,
    requiredPermissions: ["all:callLogs", "read:callLogs"]
  },
  {
    path: "/callLogs/:id",
    name: "Call Logs",
    component: ViewCallLog,
    layout: "/admin",
    invisible: true,
    exact: true,
  },
  {
    path: "/userlogs",
    name: "User Status Logs",
    mini: "UL",
    component: ListUserLogs,
    icon: "las la-clipboard-list",
    layout: "/admin",
    exact: true,
    requiredPermissions: ["all:userlogs", "read:userlogs"]
  },
  {
    path: "/contactstatuslogs",
    name: "Contact Status Logs",
    mini: "UL",
    component: ListContactStatusLogs,
    icon: "las la-user-friends",
    layout: "/admin",
    exact: true,
    requiredPermissions: ["all:contactStatusLogs", "read:contactStatusLogs"]
  },
  {
    path: "/phonenumbers",
    name: "Phone Numbers",
    mini: "BG",
    component: ListPhoneNumber,
    icon: "las la-phone-square",
    layout: "/admin",
    exact: true,
    requiredPermissions: ["all:phone_numbers", "read:phone_numbers"]
  },
  {
    path: "/phonenumbers/add",
    name: "Phone Number",
    component: EditPhoneNumber,
    layout: "/admin",
    invisible: true,
    exact: true,
  },
  {
    path: "/phonenumbers/:id",
    name: "Phone Numbers",
    component: ViewPhoneNumber,
    layout: "/admin",
    invisible: true,
    exact: true,
  },
  {
    path: "/phonenumbers/:id/edit",
    name: "Phone Numbers",
    component: EditPhoneNumber,
    layout: "/admin",
    invisible: true,
    exact: true,
  },
  {
    path: "/blockedphonenumbers",
    name: "Blocked Numbers",
    mini: "BN",
    component: ListBlockedPhoneNumber,
    icon: "las la-phone-slash",
    layout: "/admin",
    exact: true,
    requiredPermissions: ["all:phone_numbers", "read:phone_numbers"]
  },
  {
    path: "/blockedphonenumbers/add",
    name: "Blocked Number",
    component: EditBlockedPhoneNumber,
    layout: "/admin",
    invisible: true,
    exact: true,
  },
  {
    path: "/blockedphonenumbers/:id",
    name: "Blocked Numbers",
    component: ViewBlockedPhoneNumber,
    layout: "/admin",
    invisible: true,
    exact: true,
  },
  {
    path: "/blockedphonenumbers/:id/edit",
    name: "Blocked Numbers",
    component: EditBlockedPhoneNumber,
    layout: "/admin",
    invisible: true,
    exact: true,
  },
  {
    path: "/settings",
    name: "Settings",
    mini: "EC",
    icon: "las la-cog",
    component: ListAdminSettings,
    layout: "/admin",
    exact: true,
    requiredPermissions: ["all:settingsManagement", "read:settingsManagement", "all:pbxGroups", "read:pbxGroups"]
  },
  {
    path: "/settings/add",
    name: "Add Setting",
    component: EditSetting,
    layout: "/admin",
    invisible: true,
    exact: true,
  },
  {
    path: "/settings/:id",
    name: "Settings",
    component: ViewSetting,
    layout: "/admin",
    invisible: true,
    exact: true,
  },
  {
    path: "/settings/:id/edit",
    name: "Edit Setting",
    component: EditSetting,
    layout: "/admin",
    invisible: true,
    exact: true,
  },
  {
    path: "/pbxgroups/add",
    name: "Add Pbx Group",
    component: EditPbxGroup,
    layout: "/admin",
    invisible: true,
    exact: true,
  },
  {
    path: "/pbxgroups/:id",
    name: "Pbx Group",
    component: ViewPbxGroup,
    layout: "/admin",
    invisible: true,
    exact: true,
  },
  {
    path: "/pbxgroups/:id/edit",
    name: "Edit Pbx Group",
    component: EditPbxGroup,
    layout: "/admin",
    invisible: true,
    exact: true,
  },

];

export default routes;
